/**
 * Cosmetic, client-side grouping of enrichment field codes for the New batch "Content
 * generation" section (K2 design, #205/S11). `FieldOption` on the wire carries no group, so this
 * is presentation-only: known codes map to the design's four buckets, and anything this app
 * hasn't seen yet lands in `other` rather than disappearing — a connector adding a field never
 * silently hides it.
 */
export type NewRunFieldGroup = 'content' | 'classification' | 'attributes' | 'media' | 'other';

export const NEW_RUN_FIELD_GROUP_ORDER: NewRunFieldGroup[] = [
  'content',
  'classification',
  'attributes',
  'media',
  'other',
];

const GROUP_BY_CODE: Record<string, NewRunFieldGroup> = {
  TITLE: 'content',
  DESCRIPTION: 'content',
  PRODUCT_HIGHLIGHTS: 'content',
  CARE_INSTRUCTIONS: 'content',
  CARE_INSTRUCTION: 'content',
  PRODUCT_TYPE: 'classification',
  GOOGLE_PRODUCT_CATEGORY: 'classification',
  AGE_GROUP: 'classification',
  GENDER: 'classification',
  MATERIAL: 'attributes',
  COLOR: 'attributes',
  COLOUR: 'attributes',
  SIZE: 'attributes',
  PATTERN: 'attributes',
  ADDITIONAL_IMAGE_RECOMMENDATION: 'media',
  BUNDLE_SUGGESTIONS: 'media',
};

/** The design bucket a field code falls into; unrecognised codes land in `other`. */
export function fieldGroupOf(code: string): NewRunFieldGroup {
  return GROUP_BY_CODE[code.toUpperCase()] ?? 'other';
}
